// Super Admin Dashboard Count

import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import axios from "axios";

const SuperAdminCount = () => {
  const [stats, setStats] = useState({
    totalAdmins: 0,
    activeTrial: 0,
    expiredTrial: 0,
    activeSubscription: 0,
    expiredSubscription: 0,
  });

  // Function to fetch the new requests and total visitors count
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const superadminToken = localStorage.getItem("superAdminToken");

        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/admin/stats`,
          {
            headers: {
              Authorization: `Bearer ${superadminToken}`,
            },
          }
        );

        const data = response.data;

        setStats({
          totalAdmins: data.totalAdmins || 0,
          activeTrial: data.activeTrial || 0,
          expiredTrial: data.expiredTrial || 0,
          activeSubscription: data.activeSubscription || 0,
          expiredSubscription: data.expiredSubscription || 0,
        });
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
      }
    };

    fetchStats();
  }, []);

  const cardData = [
    {
      title: "Total Companies",
      count: stats.totalAdmins,
      bg: "bg-cyan",
      icon: "gridicons:multiple-users",
    },
    {
      title: "Active Trial Subscription",
      count: stats.activeTrial,
      bg: "bg-purple",
      icon: "fa-solid:award",
    },
    {
      title: "Expired Trial Subscription",
      count: stats.expiredTrial,
      bg: "bg-info",
      icon: "fluent:people-20-filled",
    },
    {
      title: "Active Paid Subscription",
      count: stats.activeSubscription,
      bg: "bg-cyan",
      icon: "gridicons:multiple-users",
    },
    {
      title: "Expired Paid Subscription",
      count: stats.expiredSubscription,
      bg: "bg-purple",
      icon: "fa-solid:award",
    },
  ];

  return (
    <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
      {cardData.map((item, index) => (
        <div className="col" key={index}>
          <div
            className={`card shadow-none border h-100 bg-gradient-start-${
              index + 1
            }`}
          >
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    {item.title}
                  </p>
                  <h6 className="mb-0">{item.count}</h6>
                </div>
                <div
                  className={`w-50-px h-50-px ${item.bg} rounded-circle d-flex justify-content-center align-items-center`}
                >
                  <Icon icon={item.icon} className="text-white text-2xl mb-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SuperAdminCount;
